import React from "react";
import { useAuth } from "../../context/AuthContext";
import "../../../styles/components/layout/logoutOverlay.css";

/**
 * LogoutOverlay - Displays a full-screen overlay during logout to prevent
 * any intermediate display from showing before the redirect to login page.
 */
const LogoutOverlay = () => {
  const { isLoggingOut } = useAuth();

  if (!isLoggingOut) {
    return null;
  }

  return (
    <div className="logout-overlay">
      <div className="logout-overlay-content">
        <div className="logout-spinner"></div>
        <p>Logging out...</p>
      </div>
    </div>
  );
};

export default LogoutOverlay;
